import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import OEIInput from './OEIInput';
import {
  BUSINESSLINE1,
  BUSINESSLINE10,
  BUSINESSLINE2,
  BUSINESSLINE3,
  BUSINESSLINE4,
  BUSINESSLINE5,
  BUSINESSLINE6,
  BUSINESSLINE7,
  BUSINESSLINE8,
  BUSINESSLINE9,
  CHECKED,
  DISABLED,
  EMPTY,
  UNCHECKED,
  BUSINESSLINE11
} from './Constants';

function NewOECentralMappingPopover({
  newData,
  errors,
  setNewData,
  setErrors,
  setCheckedList,
  openCheckedListModel,
  checkedListModel
}) {
  const setOECentralAccountNumber = useCallback((e) => {
    setNewData({ ...newData, oeCentralAccountNumber: e });
    setErrors({ ...errors, error3: EMPTY });
  }, [setNewData, setErrors, newData, errors]);

  const setOECentralAccountName = useCallback((e) => {
    setNewData({ ...newData, oeCentralAccountName: e });
    setErrors({ ...errors, error4: EMPTY });
  }, [setNewData, setErrors, newData, errors]);

  const getAllCheckedList = useCallback((data) => {
    let list = [];
    data.forEach(item => list.push(...item.checkedList));
    return list;
  }, []);

  const setStatus = useCallback((totalList, checkedList, key) => {
    return checkedList.includes(key) ? CHECKED : totalList.includes(key) ? DISABLED : UNCHECKED;
  }, []);

  const removeBusinessline = useCallback((businessLine) => {
    let totalList = getAllCheckedList(newData.passportData);
    const indexOfBusinessline = totalList.indexOf(businessLine);
    if (indexOfBusinessline > -1) {
      totalList.splice(indexOfBusinessline, 1);
    }
    let list = newData.checkedList;
    const index = list.indexOf(businessLine);
    list.splice(index, 1);
    setNewData({ ...newData, checkedList: list });
    setCheckedList([
      { key: BUSINESSLINE1, value: setStatus(totalList, list, BUSINESSLINE1) },
      { key: BUSINESSLINE2, value: setStatus(totalList, list, BUSINESSLINE2) },
      { key: BUSINESSLINE3, value: setStatus(totalList, list, BUSINESSLINE3) },
      { key: BUSINESSLINE4, value: setStatus(totalList, list, BUSINESSLINE4) },
      { key: BUSINESSLINE5, value: setStatus(totalList, list, BUSINESSLINE5) },
      { key: BUSINESSLINE6, value: setStatus(totalList, list, BUSINESSLINE6) },
      { key: BUSINESSLINE7, value: setStatus(totalList, list, BUSINESSLINE7) },
      { key: BUSINESSLINE8, value: setStatus(totalList, list, BUSINESSLINE8) },
      { key: BUSINESSLINE9, value: setStatus(totalList, list, BUSINESSLINE9) },
      { key: BUSINESSLINE10, value: setStatus(totalList, list, BUSINESSLINE10) },
      { key: BUSINESSLINE11, value: setStatus(totalList, list, BUSINESSLINE11) }
    ]);
  }, [getAllCheckedList, setNewData, setCheckedList, newData, setStatus]);

  const BusinessLineItem = ({ businessLine }) => (
    <div className="email_row">
      <div title={businessLine} style={{ width: '205px' }} className="m overflow-ellipsis">{businessLine}</div>
      <button onClick={() => removeBusinessline(businessLine)} type="button" style={{ color: "#ff0000" }} className="default-button default-button--slim-edit default-button--link visible-while-hovered email-remove-label">
        <span>Remove</span>
      </button>
    </div>
  );

  return (
    <>
      <OEIInput
        value={newData.oeCentralAccountNumber}
        setValue={setOECentralAccountNumber}
        errorMessage={errors.error3}
        newData={newData}
        name="oeCentralAccountNumber"
        label="OE Central Account Number"
        showError={false}
      />
      <OEIInput
        value={newData.oeCentralAccountName}
        setValue={setOECentralAccountName}
        errorMessage={errors.error4}
        newData={newData}
        name="oeCentralAccountName"
        label="OE Central Account Name"
        showError={false}
      />
      <div className="oe-form-field">
        <label style={{ color: '#1A1A1A', paddingLeft: '0px', display: 'flex' }} className="attendee-list__label event_form__items-section__title">
          Business Line(s)
        </label>
        {newData.checkedList && newData.checkedList.map((businessLine) => (
          <BusinessLineItem key={businessLine} businessLine={businessLine} />
        ))}
        <div className="m">
          <button
            type="button"
            onClick={() => { openCheckedListModel(true); setErrors({ ...errors, error5: EMPTY }); }}
            className="email-new"
            style={{ cursor: 'pointer', backgroundColor: checkedListModel ? '#C4F8E4' : '', color: checkedListModel ? '#1A1A1A' : '' }}
          >
            <span>+ Business Line(s)</span>
          </button>
        </div>
        <div className="oe-form-field__error">{errors.error5}</div>
      </div>
    </>
  );
}

NewOECentralMappingPopover.propTypes = {
  newData: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setNewData: PropTypes.func.isRequired,
  setErrors: PropTypes.func.isRequired,
  setCheckedList: PropTypes.func.isRequired,
  openCheckedListModel: PropTypes.func.isRequired,
  checkedListModel: PropTypes.bool.isRequired
};

export default NewOECentralMappingPopover;